import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  isDevMode,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideCheckNoChangesConfig,
} from '@angular/core';
import { MAT_ICON_DEFAULT_OPTIONS, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { authHttpInterceptorFn, provideAuth0 } from '@auth0/auth0-angular';
import { environment } from '@environments/environment';
import { provideQuillConfig } from 'ngx-quill/config';
import { provideMaterialLayerStyles } from '../material-layer';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    ...(isDevMode() ? [provideCheckNoChangesConfig({ exhaustive: true, interval: 1000 })] : []),
    provideHttpClient(withInterceptors([authHttpInterceptorFn])),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideQuillConfig({
      defaultEmptyValue: '',
      format: 'html',
      sanitize: true,
      suppressGlobalRegisterWarning: true,
      theme: 'snow',
      trackChanges: 'user',
    }),
    {
      provide: MAT_ICON_DEFAULT_OPTIONS,
      useValue: {
        fontSet: 'material-symbols-outlined',
      },
    },
    provideMaterialLayerStyles('material-base'),
    provideAppInitializer(() => {
      const registry = inject(MatIconRegistry);
      const sanitizer = inject(DomSanitizer);

      registry.addSvgIconResolver((name, ns) => {
        return sanitizer.bypassSecurityTrustResourceUrl(`/assets/images/icons/${ns}/${name}.svg`);
      });
    }),
    provideAuth0({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      authorizationParams: {
        redirect_uri: `${window.location.origin}/auth/callback`,
        audience: environment.auth0.audience,
        scope: 'openid profile email offline_access',
      },
      cacheLocation: 'localstorage',
      useRefreshTokens: true,
      useRefreshTokensFallback: true,
      errorPath: '/auth/error',
      httpInterceptor: {
        allowedList: [
          {
            uri: `${environment.coreOrigin}/early-access/api/v1/*`,
            allowAnonymous: true,
          },
          {
            uri: `${environment.coreOrigin}/*`,
          },
        ],
      },
    }),
  ],
};
